var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-container',{staticClass:"home-table-item-wrapper",attrs:{"contentClass":`home-table-item-wrapper__content _scroll ${_vm.contentClass}`}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }